import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUSearchPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14.317,
	height: 14.306,
	viewBox: "0 0 14.317 14.306",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "u_search-plus",
		d: "M16.1,15.079l-2.654-2.633a6.439,6.439,0,1,0-.994.994l2.633,2.633a.711.711,0,0,0,1.016-.994ZM8.433,13.441a5.008,5.008,0,1,1,3.541-1.467A5.008,5.008,0,0,1,8.433,13.441Z",
		transform: "translate(-1.979 -1.979)"
	})
});
export default SvgUSearchPlus;
